var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc403Dark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.48 273.73C55.48 273.73 57.8 345.73 117.91 393.73C178.02 441.73 261.32 445.16 328.75 449.73C396.18 454.3 447.98 416.11 455.75 358.41C463.52 300.71 412.03 283.77 384.07 218.08C356.11 152.39 358.64 130.8 299.49 90.4C240.34 50 147.8 74.81 99.29 144C50.78 213.19 55.48 273.73 55.48 273.73Z",
    fill: "#5D9E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.48 273.73C55.48 273.73 57.8 345.73 117.91 393.73C178.02 441.73 261.32 445.16 328.75 449.73C396.18 454.3 447.98 416.11 455.75 358.41C463.52 300.71 412.03 283.77 384.07 218.08C356.11 152.39 358.64 130.8 299.49 90.4C240.34 50 147.8 74.81 99.29 144C50.78 213.19 55.48 273.73 55.48 273.73Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.61 179.69V153.92C83.61 135.68 98.77 120.84 117.4 120.84C136.03 120.84 151.19 135.68 151.19 153.92V179.69H164.66V153.92C164.66 128.41 143.46 107.65 117.4 107.65C91.34 107.65 70.14 128.41 70.14 153.92V179.69H83.61Z",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.32 179.87H65.14V265.22H168.32V179.87Z",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.46 215.32C127.373 212.398 126.151 209.626 124.053 207.59C121.956 205.554 119.148 204.415 116.225 204.415C113.302 204.415 110.494 205.554 108.397 207.59C106.299 209.626 105.077 212.398 104.99 215.32C105.002 217.317 105.558 219.273 106.597 220.979C107.636 222.684 109.12 224.074 110.89 225L109 244.38H123.45L121.56 225C123.33 224.074 124.814 222.684 125.853 220.979C126.892 219.273 127.448 217.317 127.46 215.32Z",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.64 267.99L206.95 266.3V265.88L203.79 266.09L200.64 265.88V266.3L174.95 267.99L156 423.79H174.95L203.16 299.57H204.43L232.64 423.79H251.59L232.64 267.99Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156 423.78L151.37 430.94L137.05 437.26C136.296 437.677 135.665 438.286 135.222 439.025C134.78 439.765 134.541 440.608 134.53 441.47V446.94H175.37C175.611 443.998 175.611 441.042 175.37 438.1C174.95 433.89 174.95 423.78 174.95 423.78H156Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.53 442.31V446.94H175.37C175.37 446.94 175.56 444.94 175.56 442.31H134.53Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.51 423.78L256.14 430.94L270.46 437.26C271.214 437.677 271.845 438.286 272.288 439.025C272.73 439.765 272.969 440.608 272.98 441.47V446.94H232.14C231.899 443.998 231.899 441.042 232.14 438.1C232.56 433.89 232.56 423.78 232.56 423.78H251.51Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M273 442.31V446.94H232.14C232.14 446.94 231.96 444.94 231.95 442.31H273Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.07 195.51C164.07 195.51 134.07 237.67 134.07 240.76C134.07 243.85 138.84 267.71 146.42 269.95C154 272.19 158.21 268.27 159.61 260.41C161.01 252.55 156.24 241.32 156.24 241.32L170.24 228.69L164.07 195.51Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.25 259.29C158.25 259.29 166.95 257.88 169.2 258.44C171.45 259 173.13 264.34 173.13 264.34C173.13 264.34 173.97 272.2 172.56 273.88C171.15 275.56 164.42 277.53 161.62 278.09C158.82 278.65 152.91 272.2 150.62 268.27C148.33 264.34 152.35 257.6 158.25 259.29Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.38 193.6L164.07 195.51L174.01 261.86H233.09L242.08 195.89L234.05 192.83L204.41 186.33L170.38 193.6Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236.34 215.78L235.01 225.34L224.68 227.82L214.16 223.62L214.93 215.01L236.34 215.78Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.35 225.34C226.355 225.34 227.17 224.525 227.17 223.52C227.17 222.515 226.355 221.7 225.35 221.7C224.345 221.7 223.53 222.515 223.53 223.52C223.53 224.525 224.345 225.34 225.35 225.34Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.1 198.57L203.65 205.07L196.57 250.19L204.03 262.05L212.83 249.62L205.37 205.26L211.68 199.14L204.99 190.54L198.1 198.57Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.75 187.29L167.32 193.6L168.09 196.66L192.94 189.77L192.75 187.29Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.59 186.52L239.02 192.83L238.26 195.89L213.4 189.01L213.59 186.52Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M239 192.83C239 192.83 248.62 195 254.51 198.37C260.4 201.74 261.81 209.32 258.44 217.74C255.07 226.16 244.69 225.04 239.92 222.74C235.15 220.44 233.74 212.08 234.58 208.43",
    fill: "#92E3A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239 192.83C239 192.83 248.62 195 254.51 198.37C260.4 201.74 261.81 209.32 258.44 217.74C255.07 226.16 244.69 225.04 239.92 222.74C235.15 220.44 233.74 212.08 234.58 208.43",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 184.04L191.03 185.95L191.79 205.26L204.22 196.47L217.22 205.45L218.37 186.33L214.93 183.46L193.9 184.04Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219 161.07C219 161.07 226.06 159.35 227.39 152.29C228.72 145.23 216 136.64 207.18 135.12C198.36 133.6 185.43 142.75 183.33 149.05C181.23 155.35 189.43 161.64 198.21 162.98C206.99 164.32 219 161.07 219 161.07Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M192.68 162.22C192.68 162.22 188.86 156.3 187.91 161.45C186.96 166.6 190.96 168.89 192.68 168.7C194.4 168.51 192.68 162.22 192.68 162.22Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.49 162.22C217.49 162.22 221.31 156.3 222.26 161.45C223.21 166.6 219.26 168.89 217.49 168.7C215.72 168.51 217.49 162.22 217.49 162.22Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.52 173.9V186.52L204.22 196.47L216.27 186.14V174.29L193.52 173.9Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92 158.4C191.92 158.4 191.34 170.23 192.3 174.05C193.26 177.87 199.55 185.88 204.51 187.6C209.47 189.32 216.34 179.01 217.87 175.6C219.4 172.19 218.82 157.66 218.82 157.66C218.82 157.66 216.73 152.66 212.53 151.18C208.33 149.7 195.35 147 191.92 158.4Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.85 164.68C199.85 165.58 199.44 166.31 198.93 166.31C198.42 166.31 198.01 165.58 198.01 164.68C198.01 163.78 198.42 163.05 198.93 163.05C199.44 163.05 199.85 163.78 199.85 164.68Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.56 164.68C211.56 165.58 211.15 166.31 210.64 166.31C210.13 166.31 209.72 165.58 209.72 164.68C209.72 163.78 210.13 163.05 210.64 163.05C211.15 163.05 211.56 163.78 211.56 164.68Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.84 169.24C201.652 169.195 201.456 169.193 201.267 169.235C201.078 169.277 200.901 169.361 200.75 169.48C200.598 169.6 200.475 169.753 200.391 169.927C200.307 170.101 200.263 170.292 200.263 170.485C200.263 170.678 200.307 170.869 200.391 171.043C200.475 171.217 200.598 171.37 200.75 171.49C200.901 171.61 201.078 171.693 201.267 171.735C201.456 171.777 201.652 171.775 201.84 171.73C202.242 171.739 202.634 171.608 202.95 171.36C203.246 171.708 203.612 171.988 204.024 172.183C204.437 172.378 204.886 172.482 205.342 172.49C205.798 172.497 206.25 172.408 206.669 172.227C207.088 172.046 207.463 171.778 207.77 171.44C208.067 171.633 208.415 171.734 208.77 171.73C208.958 171.775 209.154 171.777 209.343 171.735C209.532 171.693 209.709 171.61 209.86 171.49C210.012 171.37 210.135 171.217 210.219 171.043C210.303 170.869 210.347 170.678 210.347 170.485C210.347 170.292 210.303 170.101 210.219 169.927C210.135 169.753 210.012 169.6 209.86 169.48C209.709 169.361 209.532 169.277 209.343 169.235C209.154 169.193 208.958 169.195 208.77 169.24",
    fill: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.84 169.24C201.652 169.195 201.456 169.193 201.267 169.235C201.078 169.277 200.901 169.361 200.75 169.48C200.598 169.6 200.475 169.753 200.391 169.927C200.307 170.101 200.263 170.292 200.263 170.485C200.263 170.678 200.307 170.869 200.391 171.043C200.475 171.217 200.598 171.37 200.75 171.49C200.901 171.61 201.078 171.693 201.267 171.735C201.456 171.777 201.652 171.775 201.84 171.73C202.242 171.739 202.634 171.608 202.95 171.36C203.246 171.708 203.612 171.988 204.024 172.183C204.437 172.378 204.886 172.482 205.342 172.49C205.798 172.497 206.25 172.408 206.669 172.227C207.088 172.046 207.463 171.778 207.77 171.44C208.067 171.633 208.415 171.734 208.77 171.73C208.958 171.775 209.154 171.777 209.343 171.735C209.532 171.693 209.709 171.61 209.86 171.49C210.012 171.37 210.135 171.217 210.219 171.043C210.303 170.869 210.347 170.678 210.347 170.485C210.347 170.292 210.303 170.101 210.219 169.927C210.135 169.753 210.012 169.6 209.86 169.48C209.709 169.361 209.532 169.277 209.343 169.235C209.154 169.193 208.958 169.195 208.77 169.24",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.36 177.07H207.35",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.48 161.27C191.48 161.27 191.62 165.11 192.9 164.11C194.18 163.11 194.6 156.59 193.47 155.74C192.34 154.89 191.48 159.29 191.48 161.27Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.11 161.27C216.11 161.27 216.26 165.11 217.53 164.11C218.8 163.11 219.24 156.59 218.1 155.74C216.96 154.89 216.11 159.29 216.11 161.27Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M191.48 158.15C191.48 158.15 191.91 158.5 191.9 158.67C193.75 159.67 198 161.51 204.9 161.88C209.794 162.049 214.639 160.862 218.9 158.45C218.9 157.94 218.9 157.64 218.9 157.63C218.73 153.16 215.41 150.18 211.3 149.04C207.26 147.928 202.969 148.141 199.06 149.65C197.077 150.398 195.328 151.657 193.99 153.3C193.48 153.86 190.78 157.59 191.48 158.15Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92 158.4C196.185 159.343 200.564 159.663 204.92 159.35C213.13 158.97 218.84 158.4 218.84 158.4C215.067 161.937 210.197 164.075 205.04 164.46C202.521 164.624 200.002 164.155 197.71 163.097C195.419 162.038 193.428 160.424 191.92 158.4Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M170.96 215.78L172.29 225.34L182.62 227.82L193.13 223.62L192.37 215.01L170.96 215.78Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M181.95 225.34C182.955 225.34 183.77 224.525 183.77 223.52C183.77 222.515 182.955 221.7 181.95 221.7C180.945 221.7 180.13 222.515 180.13 223.52C180.13 224.525 180.945 225.34 181.95 225.34Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.76 261.25H173.13V270.79H233.76V261.25Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M184.78 261.81H171.59C170.115 261.81 168.92 263.005 168.92 264.48V270.93C168.92 272.405 170.115 273.6 171.59 273.6H184.78C186.255 273.6 187.45 272.405 187.45 270.93V264.48C187.45 263.005 186.255 261.81 184.78 261.81Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.06 261.81H219.87C218.395 261.81 217.2 263.005 217.2 264.48V270.93C217.2 272.405 218.395 273.6 219.87 273.6H233.06C234.535 273.6 235.73 272.405 235.73 270.93V264.48C235.73 263.005 234.535 261.81 233.06 261.81Z",
    fill: "#4C4C4C",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M211.02 261.81H197.83V270.23H211.02V261.81Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M156.28 241.32C156.28 241.32 147.86 240.76 144.77 235.42",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 216.62C257.577 216.62 263.8 210.083 263.8 202.02C263.8 193.957 257.577 187.42 249.9 187.42C242.223 187.42 236 193.957 236 202.02C236 210.083 242.223 216.62 249.9 216.62Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 204.38C255.909 204.38 260.78 200.015 260.78 194.63C260.78 189.245 255.909 184.88 249.9 184.88C243.891 184.88 239.02 189.245 239.02 194.63C239.02 200.015 243.891 204.38 249.9 204.38Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M249.9 197.21C255.909 197.21 260.78 192.845 260.78 187.46C260.78 182.075 255.909 177.71 249.9 177.71C243.891 177.71 239.02 182.075 239.02 187.46C239.02 192.845 243.891 197.21 249.9 197.21Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M232.42 166.44C232.42 166.44 232.61 180.82 233.34 185.06C234.07 189.3 237.03 194.83 241.09 194.83C243.795 194.763 246.471 194.267 249.02 193.36C249.02 193.36 253.81 195.94 258.42 195.2C263.03 194.46 262.29 188.01 262.29 185.2C262.29 182.39 261.74 161.6 261.74 161.6C261.74 161.6 262.11 159.6 260.26 159.21C259.353 159.006 258.429 158.882 257.5 158.84V154.41C257.16 153.903 256.688 153.498 256.134 153.239C255.581 152.98 254.968 152.876 254.36 152.94C251.97 152.94 251.78 153.49 251.78 153.49V149.43C251.78 149.43 249.78 146.2 247.17 147.77C246.644 148.072 246.201 148.499 245.88 149.014C245.559 149.529 245.37 150.115 245.33 150.72L245.14 154.6C245.14 154.6 240.72 152.94 240.35 155.52C239.98 158.1 239.24 174 239.24 174C238.978 171.5 238.486 169.03 237.77 166.62C236.85 164.22 232.42 164.22 232.42 166.44Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M245.14 154.64L245.51 171.6",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M251.78 153.53L251.97 171.78",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 158.88L257.13 171.6",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M242.75 171.42L259.53 172.15",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M239.24 174C239.245 174.696 239.411 175.381 239.725 176.002C240.039 176.623 240.493 177.163 241.05 177.58C242.87 178.72 246.97 181.68 247.42 186.46",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M350 128.81V131H344.67V138.76H351.22V141H342.22V119.2H351.22V121.41H344.67V128.85L350 128.81Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M358.3 119.16C361.72 119.16 363.16 120.9 363.16 124.16V125.94C363.16 128.34 362.32 129.83 360.45 130.42C362.45 131.01 363.19 132.63 363.19 134.97V138.37C363.118 139.262 363.266 140.158 363.62 140.98H361.16C360.82 140.144 360.682 139.239 360.76 138.34V134.91C360.76 132.45 359.61 131.67 357.58 131.67H355.87V141H353.44V119.2L358.3 119.16ZM357.67 129.44C359.61 129.44 360.76 128.81 360.76 126.44V124.35C360.76 122.35 360.04 121.35 358.24 121.35H355.87V129.42L357.67 129.44Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M370.57 119.16C374 119.16 375.43 120.9 375.43 124.16V125.94C375.43 128.34 374.59 129.83 372.72 130.42C374.72 131.01 375.46 132.63 375.46 134.97V138.37C375.387 139.263 375.538 140.16 375.9 140.98H373.44C373.095 140.145 372.954 139.24 373.03 138.34V134.91C373.03 132.45 371.88 131.67 369.85 131.67H368.14V141H365.71V119.2L370.57 119.16ZM370 129.44C371.93 129.44 373.08 128.81 373.08 126.44V124.35C373.08 122.35 372.37 121.35 370.56 121.35H368.19V129.42L370 129.44Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M377.8 124.42C377.8 121.09 379.45 118.94 382.8 118.94C386.15 118.94 387.8 121.09 387.8 124.42V135.7C387.8 139 386.15 141.18 382.8 141.18C379.45 141.18 377.8 139 377.8 135.7V124.42ZM380.2 135.82C380.2 137.82 381.04 138.97 382.78 138.97C384.52 138.97 385.37 137.82 385.37 135.82V124.3C385.37 122.3 384.56 121.15 382.78 121.15C381 121.15 380.2 122.33 380.2 124.3V135.82Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M395 119.16C398.43 119.16 399.86 120.9 399.86 124.16V125.94C399.86 128.34 399.02 129.83 397.15 130.42C399.15 131.01 399.89 132.63 399.89 134.97V138.37C399.817 139.263 399.968 140.16 400.33 140.98H397.87C397.525 140.145 397.384 139.24 397.46 138.34V134.91C397.46 132.45 396.31 131.67 394.28 131.67H392.57V141H390.1V119.2L395 119.16ZM394.38 129.44C396.31 129.44 397.46 128.81 397.46 126.44V124.35C397.46 122.35 396.75 121.35 394.94 121.35H392.57V129.42L394.38 129.44Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M329.38 264.88V267.09H324.38V276.53H321.95V254.73H330.61V256.94H324.38V264.88H329.38Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M332.33 260C332.33 256.67 333.99 254.52 337.33 254.52C340.67 254.52 342.33 256.67 342.33 260V271.28C342.33 274.58 340.68 276.76 337.33 276.76C333.98 276.76 332.33 274.58 332.33 271.28V260ZM334.73 271.4C334.73 273.4 335.57 274.55 337.32 274.55C339.07 274.55 339.9 273.4 339.9 271.4V259.87C339.9 257.87 339.09 256.72 337.32 256.72C335.55 256.72 334.73 257.9 334.73 259.87V271.4Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 254.73C352.92 254.73 354.36 256.47 354.36 259.73V261.51C354.36 263.91 353.52 265.4 351.65 265.99C353.65 266.58 354.39 268.2 354.39 270.54V273.94C354.317 274.833 354.468 275.73 354.83 276.55H352.37C352.02 275.717 351.879 274.81 351.96 273.91V270.48C351.96 268.02 350.81 267.24 348.78 267.24H347.07V276.55H344.64V254.75L349.5 254.73ZM348.88 265C350.81 265 351.96 264.37 351.96 262V259.91C351.96 257.91 351.24 256.91 349.44 256.91H347.07V265H348.88Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M361.8 254.73C365.2 254.73 366.54 256.35 366.54 259.56V260.56C366.54 262.87 365.88 264.3 363.98 264.89C366.1 265.49 366.91 267.17 366.91 269.57V271.4C366.91 274.68 365.32 276.51 361.91 276.51H356.91V254.71L361.8 254.73ZM361.21 263.98C363.14 263.98 364.14 263.36 364.14 261.08V259.8C364.14 257.87 363.48 256.94 361.74 256.94H359.34V263.94L361.21 263.98ZM361.93 274.32C363.7 274.32 364.51 273.39 364.51 271.32V269.39C364.51 266.96 363.51 266.15 361.46 266.15H359.34V274.28L361.93 274.32Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M371.55 254.73V276.53H369.12V254.73H371.55Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M379.15 254.73C382.55 254.73 384.15 256.73 384.15 260.15V271.15C384.15 274.49 382.59 276.54 379.15 276.54H374.05V254.74L379.15 254.73ZM379.15 274.32C380.9 274.32 381.74 273.23 381.74 271.24V260C381.74 258 380.9 256.92 379.12 256.92H376.5V274.3L379.15 274.32Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M391.49 254.73C394.88 254.73 396.44 256.73 396.44 260.15V271.15C396.44 274.49 394.88 276.54 391.49 276.54H386.38V254.74L391.49 254.73ZM391.49 274.32C393.23 274.32 394.07 273.23 394.07 271.24V260C394.07 258 393.23 256.92 391.46 256.92H388.84V274.3L391.49 274.32Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M406.47 264.38V266.56H401.14V274.32H407.69V276.53H398.69V254.73H407.69V256.94H401.14V264.38H406.47Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M412.08 276.53H409.9V254.73H413L418 270.49V254.73H420.15V276.53H417.62L412.05 258.9L412.08 276.53Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M306.54 208.26L328.79 155.65H342.14V208.26H347.92V219.38H342.14V233.5H330.14V219.38H306.54V208.26ZM330.12 208.26V179L317.78 208.25L330.12 208.26Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M352.48 174.33C352.48 161.88 359.04 154.76 371.05 154.76C383.06 154.76 389.63 161.88 389.63 174.33V214.82C389.63 227.28 383.06 234.39 371.05 234.39C359.04 234.39 352.48 227.28 352.48 214.82V174.33ZM364.71 215.6C364.71 221.16 367.16 223.27 371.05 223.27C374.94 223.27 377.39 221.16 377.39 215.6V173.6C377.39 168.03 374.95 165.92 371.05 165.92C367.15 165.92 364.71 168.03 364.71 173.6V215.6Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M421.1 174.78C421.1 167.78 418.66 165.88 414.76 165.88C410.86 165.88 408.42 167.99 408.42 173.56V178.56H396.86V174.33C396.86 161.88 403.08 154.76 415.1 154.76C427.12 154.76 433.34 161.88 433.34 174.33V176.33C433.34 184.67 430.67 189.9 424.77 192.33C430.89 195 433.34 200.78 433.34 208.68V214.8C433.34 227.26 427.11 234.37 415.1 234.37C403.09 234.37 396.86 227.26 396.86 214.8V208.35H408.42V215.58C408.42 221.14 410.87 223.25 414.76 223.25C418.65 223.25 421.1 221.36 421.1 214.47V208.35C421.1 201.12 418.66 198.45 413.1 198.45H409V187.35H413.78C418.34 187.35 421.12 185.35 421.12 179.12L421.1 174.78Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M86.87 446.5H72.61L91.62 313.99H105.88L86.87 446.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115.39 446.5H129.64L110.63 313.99H96.38L115.39 446.5Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M289.18 446.5H274.93L293.93 313.99H308.19L289.18 446.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M317.7 446.5H331.95L312.94 313.99H298.69L317.7 446.5Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M327.66 293.21H55.73V319.57H327.66V293.21Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M334.29 293.21H62.36V319.57H334.29V293.21Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M66.81 319.57H89.89L101.82 293.21H78.74L66.81 319.57Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M158.17 293.21H135.09L123.16 319.57H146.24L158.17 293.21Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M327.21 293.21H304.13L292.21 319.57H315.29L327.21 293.21Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M270.87 293.21H247.78L235.86 319.57H258.94L270.87 293.21Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M214.52 293.21H191.44L179.51 319.57H202.59L214.52 293.21Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M332.8 304.9H287.8",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M332.01 309.31H324.91",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M61.21 308.21H106.21",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62 303.25H118.84",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M408.51 440.72H331.37V446.51H408.51V440.72Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M395.49 440.56H344.39L364.42 331.6H375.46L395.49 440.56Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M356.98 372.1H382.91L380.42 358.6H359.46L356.98 372.1Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M387.81 422.37L389.09 429.82",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M373.22 337.62L386.2 413",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M450.01 446.5H456.92",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.37 446.5H440.36",
    stroke: "#263238",
    strokeWidth: 1.16634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc403Dark);
export default __webpack_public_path__ + "static/media/ic_403_dark.81b5fdb38501e2b89c6af4950f701c19.svg";
export { ForwardRef as ReactComponent };